import React, { useEffect, useState } from "react";
import CTable from "components/common/Table";
import Box from "components/common/Box";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { makeStyles } from "@mui/styles";
import Text from "components/common/Text";
import Grid from "components/common/Grid";
import Paper from "components/common/Paper";
import Button from "components/common/Button";
import * as XLSX from "xlsx";
import Dialog from "components/common/Dialog";
import DatePickerModal from "components/common/DatePickerModal";
import SearchBar from "components/common/SearchBar";
import {FormControl,InputLabel,OutlinedInput,InputAdornment,} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import { LeadsApi } from "stores/Leads/LeadsApi";
const CustomerData = ({
  customer_data,
  onChange,
  isloading,
  totalCount,
  searchhandleChange,
  datePickerOpen,
  handleDatePickerOpen,
  handleDatePickerClose,
  from_date,
  to_date,
  fromat_date_from,
  fromat_date_to,
  onDatePickerSub,
  page,
  limit,
  onPageChange,
  handleReset
}) => {
  // eslint-disable-next-line no-unused-vars
  const [newdata, setNewData] = useState([]);
  const [customerExcelData, setcustomerExcelData] = useState("");
  const classes = useStyles();

  useEffect(() => {
    setNewData(customer_data);
  }, [customer_data]);
  useEffect(() => {
    const fetchVehicleData = async () => {
      try {
        const limit = totalCount;
        const data = await LeadsApi.getbulkLeadsData({ limit });

        setcustomerExcelData(data?.result?.customerDetails);
      } catch (error) {
        console.error("Error exporting Navigation data:", error);
      }
    };

    fetchVehicleData();
  }, [totalCount]);
  const downloadAsExcel = () => {
    const flatData = customerExcelData.map((customer) => {
      const customerData = customer;
      const {
        first_name,
        last_name,
        email,
        mobile,
        created_at,
        my_vehicles,
        my_devices,
      } = customerData;

      const vehicle = my_vehicles[0] || {};
      const device = my_devices[0] || {};
      const {
        created_at: vehicleDate,
        manufacturer,
        vehicle_model,
        vehicle_type,
        vehicle_variant,
      } = vehicle;
      const { brand, model, type } = device;

      return {
        "First Name": first_name,
        "Last Name": last_name,
        "Email": email,
        "Mobile Number": mobile,
        "Vehicle Registration Date": vehicleDate,
        "Customer Registration Date": created_at,
        "Vehicle Type": vehicle_type?.name || "",
        "Manufacturer": manufacturer?.name || "",
        "Vehicle Model": vehicle_model?.name || "",
        "Vehicle Variant": vehicle_variant?.name || "",
        "Device Brand": brand,
        "Device Model": model,
        "Device Platform": type,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(flatData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customer Data");
    XLSX.writeFile(workbook, "CustomerData.xlsx");
  };

  const columns = [
    { field: "first_name", headerName: "First Name" },
    { field: "last_name", headerName: "Last Name" },
    { field: "email", headerName: "Email" },
    { field: "mobile", headerName: "Mobile Number" },

    {
      field: "vehicleDate",
      headerName: "Vehicle Registration Date",
      valueGetter: (v, d) => {
        const data = d?.my_vehicles || [];
        return data.map((vehicle, index) => {
          if (index !== 0) return null;
          return <div key={index}>{vehicle?.created_at}</div>;
        });
      },
    },
    { field: "created_at", headerName: "Customer Registration Date" },
    {
      field: "vehicle_type",
      headerName: "Vehicle Type",
      valueGetter: (v, d) => {
        const data = d?.my_vehicles || [];
        return data.map((vehicle, index) => {
          if (index !== 0) return null;
          return <div key={index}>{vehicle?.vehicle_type?.name}</div>;
        });
      },
    },
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      valueGetter: (v, d) => {
        const data = d?.my_vehicles || [];
        return data.map((vehicle, index) => {
          if (index !== 0) return null;
          return <div key={index}>{vehicle?.manufacturer?.name}</div>;
        });
      },
    },

    {
      field: "vehicle_model",
      headerName: "Vehicle Model",
      valueGetter: (v, d) => {
        const data = d?.my_vehicles || [];
        return data.map((vehicle, index) => {
          if (index !== 0) return null;
          return <div key={index}>{vehicle?.vehicle_model?.name}</div>;
        });
      },
    },

    {
      field: "vehicle_variant",
      headerName: "Vehicle Variant",
      valueGetter: (v, d) => {
        const data = d?.my_vehicles || [];
        return data.map((vehicle, index) => {
          if (index !== 0) return null;
          return <div key={index}>{vehicle?.vehicle_variant?.name}</div>;
        });
      },
    },
    {
      field: "brand",
      headerName: "Device Brand",
      valueGetter: (v, d) =>
        (d?.my_devices || [])
          .map((e, index) =>
            index !== 0 ? null : <div key={e.id}>{e?.brand ?? ""}</div>
          )
          .filter(Boolean),
    },
    {
      field: "model",
      headerName: "Device Model",
      valueGetter: (v, d) =>
        (d?.my_devices || [])
          .map((e, index) =>
            index !== 0 ? null : <div key={e.id}>{e?.model ?? ""}</div>
          )
          .filter(Boolean),
    },
    {
      field: "type",
      headerName: "Device Platform",
      valueGetter: (v, d) =>
        (d?.my_devices || [])
          .map((e, index) =>
            index !== 0 ? null : <div key={e.id}>{e?.type ?? ""}</div>
          )
          .filter(Boolean),
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12} lg={12}>
        <Paper sx={{ p: 3, mt: 3.5, marginLeft: "5px" }}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Text
              variant="h5"
              color="#707070"
              sx={{ fontSize: "22px", marginBottom: "40px" }}
            >
              Customers
            </Text>
            <Button
              onClick={downloadAsExcel}
              className={classes.category_btn}
              variant="contained"
              color="primary"
              style={{ textTransform: "capitalize" }}
            >
              <FileDownloadIcon sx={{ fontSize: 23 }} /> Export Report
            </Button>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Box sx={{ maxWidth: 200, minWidth: 200 }}>
              <FormControl fullWidth size="small">
                <InputLabel
                  sx={{ fontSize: "14px" }}
                  className={classes.datePickerInput}
                  id="daterange-label"
                >
                  Date Range
                </InputLabel>
                <OutlinedInput
                  sx={{ height: "37px",fontSize:'11px' }}
                  label="Date Range"
                  className={classes.table_date}
                  id="outlined-adornment-amount"
                  value={
                    fromat_date_from && fromat_date_to
                      ? `${fromat_date_from} - ${fromat_date_to}`
                      : ""
                  }
                  onClick={handleDatePickerOpen}
                  endAdornment={
                    <InputAdornment position="end" sx={{cursor:'pointer'}}>
                      <EventIcon />
                    </InputAdornment>
                  }
                />
              </FormControl>
              <div></div>
            </Box>
            <Dialog
              open={datePickerOpen !== undefined ? datePickerOpen : false}
              onClose={handleDatePickerClose}
              title="Select a date range"
              children={
                <DatePickerModal
                  onClose={handleDatePickerClose}
                  onDatePickerSub={onDatePickerSub}
                  from_date={from_date}
                  to_date={to_date}
                  handleChange={onChange}
                  handleReset={handleReset}
                />
              }
            />
            <Box className={classes.searchBoxContainer}>
              <SearchBar
                onSearchChange={(value) =>
                  searchhandleChange("inputsearch", value)
                }
              />
              {/* <FilterListOutlinedIcon
                    className={classes.filterIcon}
                    onClick={() => toggleDrawer(true)}
                  /> */}
            </Box>
          </Box>
          <CTable
            columns={columns}
            data={customer_data ?? []}
            pagination={true}
            // localPagination={true}
            isLoading={isloading}
            page={page}
            onPageChange={onPageChange}
            count={totalCount + 1}
            rowsPerPage={limit}
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  table_date: {
    "@media (max-width:768px)": {
      width: "218%",
    },
  },
  category_btn: {
    height: "40px",
    fontSize: "14px",
    border: "1px solid #19AA69",
    borderRadius: "30px",
    "@media (max-width:768px)": {
      marginTop: "12px",
    },
  },
}));

export default CustomerData;
